import { axios } from '@/lib/axios';

export const getOrder = async (id: number) => {
    const { data } = await axios.get(`v1/get-orders-details/${id}`);
    return data;
};
